import React from 'react'
import { Button, Flex, Icon, Text, Tooltip } from '@workwhile/ui'
import { CheckIcon } from 'lucide-react'
import { useFieldglassIssueActionsContextValue } from '../context/FieldglassIssueActionsProvider'
import {
  AUTOMATIC_RESOLUTION_ISSUE_TYPES,
  FieldglassOperationIssueType,
} from '../constants/issueTypes'

type ResolveFieldglassIssueButtonProps = {
  issueId: number
  issueType: FieldglassOperationIssueType
}

export const ResolveFieldglassIssueButton = ({
  issueId,
  issueType,
}: ResolveFieldglassIssueButtonProps) => {
  const {
    state: { resolveFieldglassIssueMutationState },
    actions: { resolveFieldglassIssue },
  } = useFieldglassIssueActionsContextValue()

  const isAutomaticResolution =
    AUTOMATIC_RESOLUTION_ISSUE_TYPES.includes(issueType)
  const isResolving =
    resolveFieldglassIssueMutationState.resolvingIssueId === issueId

  const button = (
    <Button
      kind="small"
      variant="secondary"
      onClick={() => resolveFieldglassIssue({ issueId })}
      style={{ padding: '0 0.5rem' }}
      disabled={isAutomaticResolution || isResolving}
      loading={isResolving}
    >
      <Flex alignItems="center" gap={1}>
        <Text fontSize="12px">Mark as completed</Text>
        <Icon icon={CheckIcon} size={12} />
      </Flex>
    </Button>
  )

  if (!isAutomaticResolution) {
    return button
  }

  return (
    <Tooltip content="Resolves on its own once the shift is mapped to a job posting.">
      <span>{button}</span>
    </Tooltip>
  )
}
